import { useMediaQuery, useTheme } from "@mui/material";

/**
 * Single source of truth for "are we on a mobile/tablet viewport".
 * Matches the CSS `@media (max-width: 900px)` rules (MUI `md` breakpoint)
 * so JS-driven behavior (drawer, modal sizing) stays in sync with the CSS.
 */
export default function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("md"));
}
